import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {InputModel} from '../../../../types/control';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useSelector} from 'react-redux';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useHistory} from 'react-router-dom';
import {useLocalization} from "../../../../hooks/localization";
import {useRPC} from '../../../../hooks/rpc';

const keyExtractor = (item: InputModel) => item?.id;

export const InputListScreen = memo(function InputListScreen() {
    const {t} = useLocalization();
    const history = useHistory();

    const bridgeDeviceSet = useSetSelector(state => state.control.bridgeDeviceList);
    const inputList = useSelector(state => state.control.inputList)/*.filter(control => control.type_id !== '6')*/;
    const inputTypeSet = useSetSelector(state => state.control.inputTypeList);
    const controlSet = useSetSelector(state => state.control.controlList)
    const virtualControlSetList = useSetSelector(state => state.control.virtualControlList)
    const [rpc] = useRPC()
    const [inputCountValue, setInputCountValue] = useState<number>(0)

    const [selectedInput, setSelectedInput] = useState<InputModel>(null);


    const onCopyClick = useCallback(() => {
        history.push({pathname: '/settings/input/edit', state: {input: {...selectedInput, id: null}}});
    }, [history, selectedInput]);

    const buttons = useMemo(() => [
        {
            text: t('copy'),
            onClick: onCopyClick,
            className: 'blue',
            hidden: !(selectedInput),
        },
        {
            text: t('edit'),
            url: `/settings/input/edit/${selectedInput ? selectedInput.id : ''}`,
            className: 'orange',
            hidden: !(selectedInput),
        },
        {
            text: t('create_input'),
            url: '/settings/input/edit',
            className: 'green',
        },
    ], [t, onCopyClick, selectedInput]);

    const displayNameExtractor = useCallback(
        (item: InputModel, column: ColumnModel) => {
            if (column.key === "bridge_device_id") {
                return bridgeDeviceSet[item?.bridge_device_id]?.name
            }

            if (column.key === "control") {
                return item?.is_virtual_control
                    ? controlSet[virtualControlSetList[item?.relational_id]?.control_id]?.name || "-"
                    : controlSet[item?.relational_id]?.name || "-"
            }

            if (column.key === "type_id") {
                return inputTypeSet[item?.type_id]?.name
            }

            return item[column.key]?.toString() || "-"
        },
        [bridgeDeviceSet, inputTypeSet, controlSet, virtualControlSetList]
    )

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: `${t('input_name')} (${inputCountValue})`,
            key: 'name',
        },
        {
            length: 2,
            name: t('device'),
            key: 'bridge_device_id',
        },
        {
            length: 2,
            name: t('control'),
            key: 'control',
        },
        {
            length: 2,
            name: t('type'),
            key: 'type_id',
        },
        {
            length: 1,
            name: t('input'),
            key: 'input_number',
        },
        {
            length: 1,
            name: t('slot'),
            key: 'slot',
        },
    ], [t, inputCountValue]);
    

    useEffect(() => {
        rpc.getInputCount().then(r => setInputCountValue(r))
    }, [rpc])

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="camera-list-page" backUrl={'/settings'} searchable={true}>
                <SettingsList
                    columns={columns}
                    items={inputList}
                    listType="inputList"
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedInput}
                    onItemSelected={setSelectedInput}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
